import React from 'react';
import Ionicon from "react-ionicons";
import Loader from '../../../../../common/elements/Loader';
import AddToCartItemProfile from './AddToCartItemProfile'

export const AddToBasketProfile = props =>{

        const {isOpen, product, addToBasket, network, cancelModal } = props;

        if (!product || product.length === 0) {
            return <Loader network={ network}/>
        }

        if (!isOpen) return null;


        return (
            <div className="popup-default" role="dialog">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button type="button" className="close-popup" onClick={ cancelModal }>
                            <Ionicon icon="ion-close"/>
                        </button>
                        <AddToCartItemProfile
                            id={ product.id }
                            purchased={ product.in_basket }
                            item={ product }
                            onAddToCartClicked={ () => addToBasket(product.id) }
                            cancelModal={ cancelModal }
                        />
                    </div>
                </div>
            </div>
        );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/AddToBasketProfile.js